import { HttpErrorResponse } from '@angular/common/http';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { LoginExceptions } from '@commoncore/exception/LoginExceptions';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { PasswordEncryptorUtil } from '@mainrepo/app/core/utils/PasswordEncryptorUtil';

export class PrivateFolderImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  static singleInstance: PrivateFolderImplementation;
  public sessionKey: any;
  public disableError: boolean = false
  public mobileNumberPrivateFolder:any
  public emailPrivateFolder:any
  public exception: any;
  public isPFOTPError = false;
  public encPrivateFolderSessionKey:any;
  public requestIdPrivateFolder:any
  passwordEncryptorUtil: PasswordEncryptorUtil;
  localStorageSvc: LocalStorageSvc;
  sessionStorageService: any;
  // public showPrivateFolderDeleteModal: boolean = false
  public listService:any;
  userCustomPassword : any;
  // public showPrivateFolderResetModal:boolean = false;
  // showPrivateFolderSetupModal: boolean = false;
  public passwordError:any="";
  cleverTapEventsService:any;
  constructor(public globalService: GlobalService) {
    this.setHandler(globalService);
    this.passwordEncryptorUtil = new PasswordEncryptorUtil();
    this.exception = new LoginExceptions(globalService);
  }

  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.route = globalService.getActivatedRoute();
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.listService = globalService.getListServiceRef();
    this.cleverTapEventsService = globalService.getCleverTapEventsvc();
    
  }

  public static getInstance(globalService): PrivateFolderImplementation {
    if (this.singleInstance == null) {
      this.singleInstance = new PrivateFolderImplementation(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  sendOTP(password,resend) {
    let userData = this.localStorageSvc.getUserData(true);
    this.userCustomPassword = password;
    var serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["privateFolderSendOTP"];
    if(userData["privateFolder"]["isPPFEnabled"] == "Y") {
      serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["privateFolderResetOTP"];
    }
    var self = this
    return new Promise(function (resolve, reject) {
      self.http.get(serviceUrl).subscribe(
        (suc) => {
          self.universalService.showLoader = false;          
          self.mobileNumberPrivateFolder = suc['mobileNumber'];
          self.emailPrivateFolder = suc['emailId'];
          self.requestIdPrivateFolder = suc['requestId'];
          if (self.mobileNumberPrivateFolder != undefined && self.emailPrivateFolder != undefined) {
            self.universalService.otpReceivedOn = self.mobileNumberPrivateFolder + " & " + self.emailPrivateFolder
            if(resend)
                self.universalService.showToast(TOAST["OTP_SENT_SUCCESSFULLY_BOTH"], "success")
          } else if (self.mobileNumberPrivateFolder == undefined && self.emailPrivateFolder != undefined) {
            self.universalService.otpReceivedOn = " " + self.emailPrivateFolder
            if(resend)
                self.universalService.showToast(TOAST["OTP_SENT_SUCCESSFULLY"], "success")
          } else if (self.mobileNumberPrivateFolder != undefined && self.emailPrivateFolder == undefined) {
            self.universalService.otpReceivedOn = " " + self.mobileNumberPrivateFolder
            if(resend)
                self.universalService.showToast(TOAST["OTP_SENT_SUCCESSFULLY_MOBILE"], "success")
          }



          self.getPrivateFolderHash(password)
          self.universalService.showPassPhraseReset = false;
          AppEvents.globalObservable.next({"otpverificationrequired":true,"moduleType":"privatefolder","source":self.universalService.otpReceivedOn});
          resolve(suc)
        },
        (error) => {
          self.universalService.showLoader = false;
          console.log("error from send OTP", error);
          resolve(error)
        },
      );
    })
  }

  getPrivateFolderHash(password) {
    var userData = this.localStorageSvc.getUserData(true);
    //this.universalService.privateFolderHash = this.passwordEncryptorUtil.getHash(this.localStorageSvc.getUserId(true), password);////userId,passPhrase
    this.universalService.privateFolderHash = this.passwordEncryptorUtil.getHash(userData["userId"], password);////userId,passPhrase
  }

  async enablePrivateFolder(otp) {
    var self = this;
    this.isPFOTPError = false;
    var userData = this.localStorageSvc.getUserData(true);
    let params = {};
    let is2FAEnabled = self.localStorageSvc.getTwoFAEnable(true);
    if(is2FAEnabled == 'Y') {
      await self.getPrivateFolderHash(this.userCustomPassword);
      //let StringToEncrypt = self.localStorageSvc.getUserId(true) + "#" + self.universalService.twoFAHash + "#" + this.universalService.privateFolderHash + "#" + new Date().getTime();      
      let StringToEncrypt = userData["userId"] + "#" + self.universalService.twoFAHash + "#" + this.universalService.privateFolderHash + "#" + new Date().getTime();
      //let encPrivateFolder2FAHash = await self.passwordEncryptorUtil.encryptPassPhrase(StringToEncrypt, self.localStorageSvc.getPrivateFolderSessionKey(true))
      let encPrivateFolder2FAHash = await self.passwordEncryptorUtil.encryptPassPhrase(StringToEncrypt, userData["sessionKey"]);
      params = {
        'enc2FAPPFHash': encPrivateFolder2FAHash,
      };
    } else {
      //let StringToEncrypt = self.localStorageSvc.getUserId(true) + "#" + self.universalService.privateFolderHash + "#" + new Date().getTime();
      let StringToEncrypt = userData["userId"] + "#" + self.universalService.privateFolderHash + "#" + new Date().getTime();
      let encPrivateFolderHash = await self.passwordEncryptorUtil.encryptPassPhrase(StringToEncrypt,otp);    
      params = {
        'requestId': self.requestIdPrivateFolder,
        'encOtpPPFHash': encPrivateFolderHash,
      };
    }
    
    var serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["privateFolderEnablePassword"];
    if(userData["privateFolder"]["isPPFEnabled"] == "Y") {
      await this.listService.getPPFToken();
      serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["privateFolderResetPassword"];
    }
    
    
    return new Promise(function (resolve, reject) {
      self.http.post(serviceUrl, params).subscribe(
        async (suc) => {
          self.universalService.showLoader = false;
          self.localStorageSvc.setPrivateFolderKey(suc.privateFolderKey);
          self.localStorageSvc.setPrivateFolderPassword(self.userCustomPassword);
          self.sessionStorageService.setCurrentPrivateFolderKey(suc.privateFolderKey,true);
          AppEvents.globalObservable.next({"otpverificationrequired":false});
          self.listService.deSelectAll(null);
          if (self.universalService.isPassphraseReset || userData["privateFolder"]["isPPFEnabled"] == "Y") {
            self.universalService.showToast(TOAST["PRIVATE_FOLDER_PASSWORD_RESET_SUCCESS"], "success");
          } else if(userData["privateFolder"]["isPPFEnabled"] == "N"){
            self.universalService.showToast(TOAST["PRIVATE_FOLDER_ENABLED_SUCCESS"], "success");
            self.cleverTapEventsService.pfCreated();

          }
          self.universalService.isPassphraseReset = false
          if(userData["privateFolder"]["isPPFEnabled"] == "N") {
            userData["privateFolder"]["isPPFEnabled"] = "Y";
            AppEvents.updateAuthData.next({updateAuthData:true,userData:userData});
            self.universalService.fetchJSONContent(false); //When we re-setup PF, we need to fetch options again on repo
            self.router.navigate(['privatefolder']);
          }

          AppEvents.globalObservable.next({"leftMenuContents":true});
          
          self.universalService.disableModalBackdrop();
          // self.enableDisablePrivateFolderSettings(true);
          resolve(suc)
        },
        (error) => {
          self.universalService.showLoader = false;
          self.exception.handleLoginError('OTP', error);
          AppEvents.globalObservable.next({"otpverificationerror":true,"message":self.exception.errorMessage});
          self.isPFOTPError = true;
          setTimeout(function () {
            (<HTMLInputElement>document.getElementById("digit1")).focus();
          }, 500);
          if (userData["privateFolder"]["isPPFEnabled"] == "Y") {
            // AppEvents.optionSelected.next({ enablePrivateFolder: true });
          } else {
            // AppEvents.optionSelected.next({ enablePrivateFolder: false });
          }

          reject(error)
        },
      );
    })
  }

  
  async disablePrivateFolder(serviceUrl, password) {
    var self = this;
    var userData = this.localStorageSvc.getUserData(true);
	  await self.listService.getPPFTokenWithPassword(password)
    let pfKey = self.localStorageSvc.getPrivateFolderKey();
    let params = {
      'encPPFHash': this.universalService.header_X_PPF_TOKEN,
      'privateFolderKey': pfKey,
    };
    
    self.http.post(serviceUrl, params).subscribe(
      async (suc) => {
        self.universalService.showLoader = false;
        self.disableError = false
        self.localStorageSvc.removePrivateFolderKey();// s etPrivateFolderSessionKey(self.encPrivateFolderSessionKey,true)
        self.universalService.showToast(TOAST["PRIVATE_FOLDER_DISABLED_SUCCESS"], "success");
        userData["privateFolder"]["isPPFEnabled"] = "N";
        AppEvents.updateAuthData.next({updateAuthData:true,userData:userData});
        AppEvents.globalObservable.next({"leftMenuContents":true});
        return true;
        //  resolve(suc)
      },
      (error) => {
        self.universalService.showLoader = false;
        self.disableError = true
        self.universalService.showToast(TOAST["GENERIC_ERROR"], "success");
        return false;
      },
    );
    //})
  }

  async validatePrivateFolderAceess(url,password){
    await this.listService.getPPFTokenWithPassword(password)
    let userData = this.localStorageSvc.getUserData(true);
    let classRef = this;
    var param = {
      "encPPFHash": this.universalService.header_X_PPF_TOKEN,
    };
    return new Promise(function(resolve, reject){
			classRef.http.post(url,param).subscribe(//,{observe: 'response'}
				(suc) => { 
          classRef.localStorageSvc.setPrivateFolderPassword(password);
          classRef.localStorageSvc.setPrivateFolderKey(suc.privateFolderKey);
          classRef.sessionStorageService.setCurrentPrivateFolderKey(suc.privateFolderKey,true)
          if(classRef.universalService.currentTab == 'Private Folder'){
            classRef.sessionStorageService.setCurrentFolderKey(userData["rootFolderKey"],true);
          }
          var el = (<HTMLInputElement>document.getElementById('pfpassword'));
          if(el != undefined){
                el.value = "";
          }
          classRef.passwordError = ""
          classRef.sessionStorageService.setPrivateFolderPasswordTime(new Date().getTime())
					resolve({"validation":true});
				},
				(response:HttpErrorResponse) => { 
          console.log("error response::",response,response.error.code)
					classRef.universalService.showLoader = false;
          if(response.error.code == "SCLN0437" || response.error.code == "SCLN0433")
            classRef.passwordError = "Invalid Password, Please try again"
          reject({"validation":false,error:response});
				},
			);
		})	

  }

  

  openFolder(folder) {
    this.universalService.scrollToTopIcon = false;
    this.listService.cellclick = false;
    this.router.navigate(['privatefolder', folder.objectKey]);
    if(this.universalService.mobileSelectionModeOn){
      this.universalService.switchOffMobileSelectionMode();
    }
    this.sessionStorageService.setCurrentPrivateFolderKey(folder.objectKey);
    console.log("pfimpl currentprivateFolderObjectKey:::",this.sessionStorageService.getCurrentPrivateFolderKey(true));
    this.universalService.isServerError = false;
    if (folder.parentObjectName == 'Private Folder' || this.globalService.getFolderServiceRef().breadCrumbsList.length == 1) {
      this.universalService.selectedFile = folder;
      this.globalService.getFolderServiceRef().manageBreadCrumbs(folder.objectKey, folder.objectName, folder);
      this.universalService.openFolderContent = true;
      this.universalService.insideFolder = true;
      setTimeout(() => {
        this.universalService.showTopMenu = false;
        this.universalService.hideTopMenuOptions();  
      }, 100)
      return true;
    } else {
      this.universalService.selectedFile = folder;
      this.universalService.showTopMenu = false;
      this.universalService.hideTopMenuOptions();  
      this.universalService.openFolderContent = true;
      this.universalService.insideFolder = true;
      this.globalService.getFolderServiceRef().clickedFolderName = folder.objectName;
      this.globalService.getFolderServiceRef().manageBreadCrumbs(folder.objectKey, folder.objectName, folder);
      this.universalService.foldersArray = [];
      return true;
    }  


  }

}
